import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setIFrameUrl } from '@innovyze/stylovyze/lib/actions';
import { VideoIndicator } from './WhatsNewCard.styles';
export const WhatsNewCard = ({ title, thumbnail, description, link, hasVideo, }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const handleCardClick = () => {
        dispatch(setIFrameUrl(link));
        history.push('whats-new/detail');
    };
    return (React.createElement(Card, { sx: { width: 345, height: 350, position: 'relative' }, onClick: handleCardClick },
        React.createElement(CardActionArea, null,
            React.createElement(CardMedia, { component: "img", image: thumbnail, alt: title }),
            hasVideo ? React.createElement(VideoIndicator, null) : null,
            React.createElement(CardContent, { style: { paddingBottom: '100px' } },
                React.createElement(Typography, { gutterBottom: true, variant: "h4", fontSize: 16, fontWeight: 600 }, title),
                React.createElement(Typography, { variant: "body1", color: "#666", fontSize: 14 }, description)))));
};
